import { BugOutlined } from '@ant-design/icons'
import React from 'react'
import styled from 'styled-components'

type Props = {
  onClick: () => void
}

export const ReportBugButton: React.FC<Props> = ({ onClick }) => (
  <Button type="button" onClick={onClick}>
    <BugOutlined />
    <span>Report bug</span>
  </Button>
)

const Button = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 6px 12px;
  min-width: 105px;
  background: transparent;
  border: 1px solid #e3e3e3;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 12px;
  color: #000;
  white-space: nowrap;

  &:hover {
    background: #5072a426;
    border-color: #d9d9d9;
  }
`
